'use client'

import { TopNavMobileBar } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileBar'
import { TopNavMobileSlidingPanel } from '@src/components/TopNavV4/TopNavMobile/TopNavMobileSlidingPanel'

export const TopNavMobile = () => {
  return (
    <nav className="relative overflow-x-clip lg:hidden">
      <div className="z-50 h-12 w-full bg-bodi-black-text font-medium text-bodi-white">
        <TopNavMobileBar />
      </div>
      <TopNavMobileSlidingPanel />
    </nav>
  )
}
